import LicensePermissions from 'domain/entity/LicensePermissions';

import getGenericUseCase from 'use-case/genericUseCase';

const getReadLicensePermissionsUseCase = getGenericUseCase<LicensePermissions, null>((client) => client(null));

export default getReadLicensePermissionsUseCase;
